<!--
 * @Description: 
 * @Version: V1.0.0
 * @Author: tmn
 * @Date: 2023-12-04 11:42:29
 * @LastEditors: tmn
 * @LastEditTime: 2025-05-22 13:42:08
 * @FilePath: PlanDetails.vue
 * @Props: 
 * @Remarks: 
-->
<template>
  <el-dialog
    :title="`${activeItem.routerType === 'MAINTENANCE' ? '保养' : '巡检'}详情`"
    :visible.sync="$parent.planDetails"
    width="55%"
  >
    <div style="height: 50vh">
      <el-table :data="tableData" height="100%" style="width: 100%">
        <el-table-column
          v-for="(v, i) in tabHead"
          :key="i"
          :prop="v.prop"
          :label="v.label"
          :width="v?.width"
          align="center"
        >
          <template slot-scope="scope">
            <template
              v-if="scope.row[v.prop] && v.prop == 'inspectionItemDevices'"
            >
              <el-table
                :data="scope.row[v.prop]"
                style="width: 100%"
                size="mini"
                border
              >
                <el-table-column
                  prop="deviceName"
                  label="点位名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="inspectionItems"
                  label="点位信息"
                  align="center"
                >
                  <template slot-scope="scope">
                    <p v-for="(v, i) in scope.row.inspectionItems" :key="i">
                      {{ v.name }}{{ v.value }}{{ v.unit }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <span v-else>{{ scope.row[v.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.planDetails = false">取 消</el-button>
      <el-button type="primary" @click="$parent.planDetails = false"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabHead: [],
      tableData: [],
    };
  },
  methods: {
    async getList() {
      let res = await api.patrolPlanPointDelete({
        taskId: this.activeItem.taskId,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v) => {
          v.time = v.actTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.actTime))
            : "";
        });
      }
    },
  },
  created() {
    if (this.activeItem.routerType === "MAINTENANCE") {
      this.tabHead = [
        { label: "设备名称", prop: "pointName" },
        { label: "保养时间", prop: "time" },
        { label: "保养人", prop: "staffName" },
      ];
    } else if (this.activeItem.routerType === "INSPECTION") {
      this.tabHead = [
        { label: "巡检点", prop: "pointName", width: 200 },
        { label: "巡检时间", prop: "time", width: 160 },
        { label: "巡检人", prop: "staffName", width: 120 },
        { label: "点位参数", prop: "inspectionItemDevices" },
      ];
    }
    this.getList();
  },
};
</script>

<style></style>
